
import {Component, Vue} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";
import CustomBtn from "@/components/CustomBtn.vue";
@Component({
    components: {CustomBtn},
})
export default class Password extends Vue {
    private alertColor: string = "";
    private alertMessage: string = "";
    private readonly: boolean = false;
    private isSaved: boolean = false;
    private rules: any = formRules;
    private valid: boolean = true;
    private token = null;
    private form: any = {
        password: "",
    };

    get passwordRulesSet(): any[] {
        return [
            this.rules.required,
            this.rules.length,
            this.rules.uppercase,
            this.rules.lowercase,
            this.rules.number,
            this.rules.special,
        ];
    }

    private mounted() {
        this.token = this.$route.params.token;
        this.getToken(this.token);
    }

    private getToken(token) {
        this.$store.dispatch("public/tokens/getOne", {token})
            .catch((err) => {
                this.readonly = true;
                this.alertColor = "red";
                this.alertMessage = `account.token.${err.response.data.error}`;
            });
    }

    private updatePassword() {
        this.$store.dispatch("public/password/updatePassword", {
          token: this.token,
          password: this.form.password,
        }).then((res) => {
            this.isSaved = true;
            this.alertColor = "green";
            this.alertMessage = "account.passwordSaved";
            this.form.password = "";
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        }).finally(() => this.$wait.end("edit-password"));
    }

}
